var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isVisible),expression:"isVisible"}],staticClass:"custom-loader",class:{
    'is-centered': _vm.isCentered,
    'has-padding': _vm.hasPadding,
    'is-absolute': _vm.isAbsolute
  }},[_c('span',{style:({ fontSize: (_vm.size + "em") })})])}
var staticRenderFns = []

export { render, staticRenderFns }